import { render, staticRenderFns } from "./teamFile.vue?vue&type=template&id=2e697e4e&scoped=true"
import script from "./teamFile.vue?vue&type=script&lang=js"
export * from "./teamFile.vue?vue&type=script&lang=js"
import style0 from "./teamFile.vue?vue&type=style&index=0&id=2e697e4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e697e4e",
  null
  
)

export default component.exports